function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 2.78653,
  cy: 17.7366,
  rx: 2.01163,
  ry: 2.01002,
  fill: "#006847"
});
var _ref3 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 14.5209,
  cy: 15.7288,
  rx: 2.01163,
  ry: 2.01002,
  fill: "#006847"
});
var _ref4 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 20.2206,
  cy: 24.4378,
  rx: 2.01163,
  ry: 2.01002,
  fill: "#006847"
});
var _ref5 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 34.6371,
  cy: 18.0725,
  rx: 2.01163,
  ry: 2.01002,
  fill: "#006847"
});
var _ref6 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 2.01096,
  cy: 2.0107,
  rx: 2.01096,
  ry: 2.0107,
  transform: "matrix(0.76261 0.646858 -0.647458 0.762101 42.5664 16.707)",
  fill: "#006847"
});
var _ref7 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 7.48038,
  cy: 11.3733,
  rx: 2.01163,
  ry: 2.01002,
  fill: "#006847"
});
var _ref8 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 19.2148,
  cy: 9.36159,
  rx: 2.01163,
  ry: 2.01002,
  fill: "#006847"
});
var _ref9 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 24.9145,
  cy: 18.0725,
  rx: 2.01163,
  ry: 2.01002,
  fill: "#006847"
});
var _ref10 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 2.01096,
  cy: 2.0107,
  rx: 2.01096,
  ry: 2.0107,
  transform: "matrix(0.76261 0.646858 -0.647458 0.762101 39.2524 8.18359)",
  fill: "#006847"
});
var _ref11 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 2.01096,
  cy: 2.0107,
  rx: 2.01096,
  ry: 2.0107,
  transform: "matrix(0.76261 0.646858 -0.647458 0.762101 50.2671 14.8906)",
  fill: "#006847"
});
var _ref12 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 11.5033,
  cy: 4.67213,
  rx: 2.01163,
  ry: 2.01002,
  fill: "#006847"
});
var _ref13 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 23.2377,
  cy: 2.66237,
  rx: 2.01163,
  ry: 2.01002,
  fill: "#006847"
});
var _ref14 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 28.9374,
  cy: 11.3733,
  rx: 2.01163,
  ry: 2.01002,
  fill: "#006847"
});
var _ref15 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 2.01096,
  cy: 2.0107,
  rx: 2.01096,
  ry: 2.0107,
  transform: "matrix(0.76261 0.646858 -0.647458 0.762101 46.6592 5.67773)",
  fill: "#006847"
});
var _ref16 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 2.01096,
  cy: 2.0107,
  rx: 2.01096,
  ry: 2.0107,
  transform: "matrix(0.76261 0.646858 -0.647458 0.762101 56.0161 9.36328)",
  fill: "#006847"
});
var _ref17 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 2.01096,
  cy: 2.0107,
  rx: 2.01096,
  ry: 2.0107,
  transform: "matrix(0.76261 0.646858 -0.647458 0.762101 63.7275 2.99805)",
  fill: "#006847"
});
function SvgMexicoGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 27,
    viewBox: "0 0 67 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMexicoGreen);
export default __webpack_public_path__ + "static/media/mexico_green.d3d256ef73153543a838b56ba0587892.svg";
export { ForwardRef as ReactComponent };